/**
 * Helper functions to generate text for nonprofit tags.
 */

export function shareTextForTag({
  shareText,
  title,
}: {
  shareText: string | null;
  title: string | null;
}) {
  return shareText
    ? shareText
    : title !== null
    ? `Join us in supporting nonprofits working on ${title}.`
    : null;
}

export function inviteHeaderText({ title }: { title: string | null }) {
  return title !== null ? `Support ${title}` : null;
}

export function getAutoGeneratedTagOgTitle({
  title,
}: {
  title: string | null;
}) {
  return title !== null
    ? `Support ${title} - Every.org - Philanthropy for everyone`
    : null;
}

export function getDescription({
  description,
  title,
}: {
  description: string | null;
  title: string | null;
}) {
  return description
    ? description
    : title !== null
    ? `Discover nonprofits supporting ${title}.`
    : null;
}
